<template>
   <div id="language">
       <div class="tos">
          <el-form :inline="true" :model="categoryPageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="categoryPageDto.cateName"></el-input>
             </el-form-item>
             <el-form-item label="商品类型：">
               <el-select v-model="categoryPageDto.cateType" clearable placeholder="请选择产品状态">
                     <el-option
                        v-for="item in lebietableData"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="sjhsearchFor(categoryPageDto.cateName)" plain>查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="right-item"  type="primary" @click=newoks()>添加</el-button>
       </div>
       <div class="tableform">
         <el-table
            row-key="cateId"
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
              :tree-props="{children: 'categoryPageVos', cateName: 'cateName'}"
             style="width: 100%">
             <el-table-column
                prop="cateName"
                label="分类名称"
                >
                <template slot-scope="{row:{ cateName }}">
                {{ cateName|| "-" }}
                </template>
             </el-table-column>
             <el-table-column
               prop="cateTypeName"
               label="分类等级"
              >
               <template slot-scope="scope">
               <el-tag
                  :type="scope.row.cateTypeName === '防治' ? 'danger' : 'warning'"
                  disable-transitions>{{scope.row.cateTypeName}}</el-tag>
               </template>
            </el-table-column>
            <el-table-column
               prop="cateType"
               label="类别"
              >
               <template slot-scope="scope">
               <el-tag
                  :type="scope.row.cateType === '产品' ? 'primary' : 'success'"
                  disable-transitions>{{scope.row.cateType}}</el-tag>
               </template>
            </el-table-column>
             <!-- <el-table-column
                prop="cateTypeName"
                label="分类标签"
                >
                <template slot-scope="{row:{ cateTypeName }}">
                {{ cateTypeName|| "—" }}
                </template>
             </el-table-column> -->
             <el-table-column
                prop="productCount"
                label="产品数量"
                >
                <template slot-scope="{row:{ productCount }}">
                {{ productCount|| "-" }}
                </template>
             </el-table-column>
      
             <!-- <el-table-column
               prop="cateLevel"
               label="分类等级"
               :filters="[{ text: '一级', value: '一级' }, { text: '二级', value: '二级' }]"
              >
               <template slot-scope="scope">
               <el-tag
                  :type="scope.row.cateLevel === '一级' ? 'primary' : 'success'"
                  disable-transitions>{{scope.row.cateLevel}}</el-tag>
               </template>
            </el-table-column> -->
             <!-- <el-table-column
                prop="cateLevel"
                label="分类等级"
                >
                <template slot-scope="{row:{ cateLevel }}">
                {{ cateLevel|| "—" }}
                </template>
             </el-table-column> -->
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="categoryPageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="categoryPageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 添加分类 -->
       <el-dialog title="添加分类" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="categoryOperatorDto" :model="categoryOperatorDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="分类名称：" prop="name">
                    <el-input v-model="categoryOperatorDto.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item label="分类标签：">
                    <el-select v-model="categoryOperatorDto.cateTypeId" clearable placeholder="请选择分类标签：">
                        <el-option
                           v-for="item in cateTypeIdtableData"
                           :key="item.id"
                           :label="item.cateTypeName"
                           :value="item.id"
                        />
                        </el-select>
                </el-form-item>
                <!-- <el-form-item label="父级分类：">
                    <el-select v-model="categoryOperatorDto.parentId" clearable placeholder="请选择父级分类">
                        <el-option
                           v-for="item in fjfltableData"
                           :key="item.cateId"
                           :label="item.cateName"
                           :value="item.cateId"
                        />
                        </el-select>
                </el-form-item> -->
                <el-form-item label="类别：">
                    <el-select v-model="categoryOperatorDto.cateType" clearable placeholder="请选择类别">
                        <el-option
                           v-for="item in lebietableData"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                        />
                        </el-select>
                </el-form-item>
                <el-form-item label="类别描述：">
                    <el-input v-model="categoryOperatorDto.cateDesc" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('categoryOperatorDto',categoryOperatorDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
         <el-form ref="categoryOperatorDto" :model="categoryOperatorDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="分类名称：" prop="name">
                    <el-input v-model="categoryOperatorDto.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item label="分类标签：">
                    <el-select v-model="categoryOperatorDto.cateTypeId" clearable placeholder="请选择分类标签：">
                        <el-option
                           v-for="item in cateTypeIdtableData"
                           :key="item.id"
                           :label="item.cateTypeName"
                           :value="item.id"
                        />
                        </el-select>
                </el-form-item>
                <!-- <el-form-item label="父级分类：">
                    <el-select v-model="categoryOperatorDto.parentId" :disabled="!categoryOperatorDto.parentId" clearable placeholder="请选择父级分类">
                        <el-option
                           v-for="item in fjfltableData"
                           :key="item.cateId"
                           :label="item.cateName"
                           :value="item.cateId"
                        />
                        </el-select>
                </el-form-item> -->
                <el-form-item label="类别：">
                    <el-select v-model="categoryOperatorDto.cateType" clearable placeholder="请选择类别">
                        <el-option
                           v-for="item in lebietableData"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"
                        />
                        </el-select>
                </el-form-item>
                <el-form-item label="类别描述：">
                    <el-input v-model="categoryOperatorDto.cateDesc" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="submitForm('categoryOperatorDto',categoryOperatorDto)">确 定</el-button>
            </div>
       </el-dialog>
   </div>
   </template>
   <script>
      export default {
      name:'language',
      data(){
       return{
          categoryPageDto:{
             pageNum:1,
             pageSize:10,
             cateName:null,
             cateType:null,
          },
          tableData: [],
          fjfltableData: [],
          cateTypeIdtableData: [],
          lebietableData: [{
               label:'产品',
               value:'0'
            },{
               label:'配件',
               value:'1'
            }
            ],
          totals:10,
          increase:false,
          dialogFormVisible:false,
          categoryOperatorDto:{
            cateDesc:null,
            cateId:null,
            name:null,
            parentId:null,
            status:0,
            cateType:null,
         },
         ydyoptions: [],
         zcrules: {
            name: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
       }
      },
      created(){
       this.getlist(this.categoryPageDto)
      },
      mounted(){
      },
      methods:{
       getlist(categoryPageDto) {
          this.$api.cplbqueryPage(categoryPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.tableData = res.data.data.records
                  this.tableData.forEach(element => {
                     if (element.cateLevel == 1) {
                        element.cateLevel = "一级"
                     }
                     if (element.categoryPageVos) {
                        element.categoryPageVos.forEach(item => {
                        if (item.cateLevel == 2) {
                              item.cateLevel = "二级"
                        }
                     });  
                     }
                     if (element.cateType == 0) {
                        element.cateType = "产品"
                     }else{
                        element.cateType = "配件"
                     }
                  });
                  this.fjfltableData = res.data.data.records
                  this.totals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       cateTypegetlist() {
          this.$api.queryCateType()
          .then((res) => {
                if (res.data.code == 200) {
                  this.cateTypeIdtableData = res.data.data
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       sjhsearchFor(type){
          this.categoryPageDto.cateName = type
          this.getlist(this.categoryPageDto)
       },
       submitForm(formName){
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.operatorCate(this.categoryOperatorDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.categoryOperatorDto={
                           cateDesc:null,
                           cateId:null,
                           name:null,
                           parentId:null,
                           status:0,
                           cateType:null,
                    }
                    this.getlist(this.categoryPageDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      bianjiClick(row) {
         this.categoryOperatorDto.cateId = row.cateId
         this.dialogFormVisible = true;
         this.bjtsClick(row.cateId)
         this.cateTypegetlist()
      },
      bjtsClick(cateId){
         this.$api.cplbdetail({
               cateId:cateId
            }).then((res)=>{
               if (res.data.code == 200) {
                   let data= res.data.data
                   data.cateType = data.cateType.toString()
                   this.categoryOperatorDto = data
               } else {
                  this.$message.error(res.data.message)
               }
            })
      },
      ggmccheack(value,index){
      //   this.ggmcinfo = value
      //   this.ggmcData.forEach(element => {
      //     if (element.specificationsId == value.specificationsId) {
      //       this.ggszData = element.specificationValues
      //     }
      //   });
    },
      dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deleteCate({
               cateId:e.cateId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.categoryPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
       newoks() {
         this.increase = true
         this.getlist(this.categoryPageDto)
         this.cateTypegetlist()
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.categoryOperatorDto={
            cateDesc:null,
            cateId:null,
            name:null,
            parentId:null,
            status:0,
         }
      },
      handleCurrentChange(val) {
         this.categoryPageDto.pageNum = val
          this.getlist(this.categoryPageDto)
      },
      handleSizeChange(val) {
         this.categoryPageDto.pageSize = val
          this.getlist(this.categoryPageDto)
      },
      }
      }
   </script>
   <style scoped>
#language {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
   /* background: pink; */
   display: flex;
   width: 40%;
   align-items: center;
   justify-content: space-around;
   margin: auto;
   margin-top: 30px;
}
.zcyhtk /deep/ .el-form-item__label {
   width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
   margin-left: 120px !important;
}
   </style>


// WEBPACK FOOTER //
// src/components/management/classification.vue